import { useEffect } from "react";

export /**
 *
 * Attaches an outside click event listener to the given ref
 * @param {*} ref
 * @param {*} callback
 */
const useOutsideClick = (ref, callback) => {
  const handleClick = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      callback(event.target);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
};
